import ET6Video from "../../Components/ET6Video/ET6Video";
import ScrollPage, {
  SectionItem,
} from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import Featured from "../../Content/TimeLine/Featured";
import TimeLine from "../../Content/TimeLine/TimeLine";
import TradeShowNews from "../../Content/TradeShow/TradeShowNews";
import ElfDemoNew from "../../Content/ElfDemo/ElfDemoNews";

interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  // { label: "Trade Shows",        id: "trade-shows" },
  { label: "Featured", id: "featured" },
  { label: "Timeline", id: "timeline" },
  { label: "ET6", id: "et6" },
];

const News: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
      <ElfDemoNew />
    </Section>
    <Section section={Sections[0].id}>
      <TradeShowNews />
    </Section>
    <Section section={Sections[0].id}>
      <Featured />
    </Section>
    <Section section={Sections[1].id}>
      <TimeLine />
    </Section>
    <Section section={Sections[2].id}>
      <ET6Video />
    </Section>
  </ScrollPage>
);

export default News;
